const InfoBox = ({ wrapperClassName, message }) => {
  return (
    <div className={`info-box ${wrapperClassName}`}>
      <div>{message}</div>
    </div>
  );
};

export default InfoBox;
